<template>
  <div class="order-detail">
    <div class="order-main container margin-b20">
      <div class="common">
        {{ type == 'orderConfirm' ? '确认订单' : '订单详情' }}
      </div>
      <div class="margin-b10" style="font-size: 14px">
        订单编号：{{ orderBaseInfo.orderNo }}
      </div>
      <!-- 订单详情-->
      <order-detail-show
        :shipmentInfo="shipmentInfo"
        :orderBaseInfo="orderBaseInfo"
        :invoiceInfo="invoiceInfo"
      />
    </div>
    <div class="shopping container" style="padding-top: 20px">
      <div class="common">商品清单</div>
      <el-form ref="productForm" :model="productForm">
        <TableList
          style="margin-top: 16px"
          :loading="loading"
          :table-data="
            tableData.slice(
              (currentPage - 1) * pageSize,
              currentPage * pageSize
            )
          "
          :table-label="
            orderBaseInfo.hasOverShipment == 1 ? tableParam : tableLabel
          "
        >
          <template v-slot:aiCheckResultHeader>
            <div class="flex-all-center">
              AI审查建议结果
              <eui-tooltip :content="aiCheckResultTip" placement="top">
                <eui-icon
                  icon="eicon-r-changjianwenti"
                  fontSize="14px"
                  color="#666666"
                />
              </eui-tooltip>
            </div>
          </template>
          <template v-slot:productName="slot">
            <e-tooltip :content="slot.scope.row.productName" :set-length="26" />
          </template>
          <template v-slot:displaySkuOptions="slot">
            <div
              class="break"
              v-if="
                slot.scope.row.displaySkuOptions &&
                slot.scope.row.displaySkuOptions.length < 8
              "
            >
              {{ slot.scope.row.displaySkuOptions }}
            </div>
            <div v-else>
              <eui-tooltip
                class="item"
                effect="dark"
                :content="slot.scope.row.displaySkuOptions"
                placement="top"
                style="height: 44.8px"
              >
                <div class="break">{{ slot.scope.row.displaySkuOptions }}</div>
              </eui-tooltip>
            </div>
          </template>
          <template v-slot:productSkuCode="slot">
            <e-tooltip
              :content="slot.scope.row.productSkuCode"
              :set-length="16"
            />
          </template>
          <!--单项运费-->
          <template v-slot:shippingCost="slot">
            <el-input
              v-model="slot.scope.row.shippingCost"
              v-if="type == 'orderConfirm' && handleChange()"
              oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value>999999999.99)value=999999999.99;if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
              @input="
                slot.scope.row.shippingCost =
                  slot.scope.row.shippingCost.replace(/[^0-9.]/g, '')
              "
              min="0"
              @change="calFee(slot.scope.row, 'shippingCost')"
              class="no-border"
            ></el-input>
            <div v-else>
              <span
                v-if="!handleChange() && orderBaseInfo.orderStatusNum == 17"
                >{{
                  slot.scope.row.shippingCost ? slot.scope.row.shippingCost : 0
                }}</span
              >
              <span v-else>{{
                Number(
                  orderBaseInfo.invoiceModeCode != 1
                    ? slot.scope.row.shippingCost
                      ? slot.scope.row.shippingCost
                      : 0
                    : (orderBaseInfo.orderStatusNum == '17' ||
                        orderBaseInfo.orderStatusNum == '18') &&
                      slot.scope.row.shippingCost
                    ? slot.scope.row.shippingCost
                    : 0
                ).toFixed(2)
              }}</span>
            </div>
          </template>
          <!--商品单价含税-->
          <template
            v-slot:shoppingUnitPrice="slot"
            v-if="type == 'orderConfirm' && handleChangePrice()"
          >
            <div class="red line">
              <span style="margin-right: 4px">¥</span>
              <el-input
                v-model="slot.scope.row.price"
                oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/^(\-)*(\d+)\.(\d\d).*$/,'$1$2.$3');if(value>999999999.99)value=999999999.99;if(value<0)value=null;if((value[0] == 0 && value[1] > 0) || value == '00')value=value.slice(1);"
                @input="
                  slot.scope.row.price = slot.scope.row.price.replace(
                    /[^0-9.]/g,
                    ''
                  )
                "
                min="0"
                @change="calFee(slot.scope.row, 'price')"
                class="no-border"
              ></el-input>
            </div>
          </template>
          <template v-slot:shoppingUnitPrice="slot" v-else>
            <div
              class="jc-price-container"
              v-if="
                slot.scope.row.price && Number(slot.scope.row.priceType) === 4
              "
            >
              <img
                height="20px"
                width="44px"
                src="../../../../assets/img/product/jc-icon@2x.png"
                alt="集采"
              />
              <div class="jc-price">
                ￥<span>{{
                  moneyToFixed(
                    slot.scope.row.priceWithMarkup &&
                      slot.scope.row.priceWithMarkup !== '0.00'
                      ? slot.scope.row.priceWithMarkup
                      : slot.scope.row.price
                  )
                }}</span>
              </div>
            </div>

            <div class="red flex-all-center" v-else>
              <img
                height="16px"
                width="45px"
                class="good-price-box"
                v-if="Number(slot.scope.row.priceType) === 3"
                src="../../../../assets/img/product/good-price-icon.png"
                alt="惠享价"
              />
              ¥
              {{
                Number(
                  slot.scope.row.priceWithMarkup &&
                    slot.scope.row.priceWithMarkup !== '0.00'
                    ? slot.scope.row.priceWithMarkup
                    : slot.scope.row.price
                ).toFixed(2)
              }}
            </div>
          </template>
          <!--购买数量 -->
          <template v-slot:quantity="slot">
            <span
              v-if="
                orderBaseInfo.orderStatusNum == 22 ||
                orderBaseInfo.orderStatusNum == 103 ||
                orderBaseInfo.orderStatusNum == 6 ||
                (orderBaseInfo.orderStatusNum == 72 &&
                  (orderBaseInfo.orderStatusOld == 22 ||
                    orderBaseInfo.orderStatusNum == 103 ||
                    orderBaseInfo.orderStatusNum == 6))
              "
              >{{ slot.scope.row.settlementQuantity }}</span
            >
            <span v-else>{{ slot.scope.row.quantity }}</span>
          </template>
          <!--小计-->
          <template v-slot:subtotal="slot">
            <div class="red">
              {{ Number(slot.scope.row.subtotal).toFixed(2) }}
            </div>
          </template>
          <!--附件-->
          <template v-slot:attachmentUpload="{ scope: { row, $index } }">
            <!-- <el-form-item
              :prop="'aiCheckFileList.' + $index + '.attachList'"
              :rules="{
                required: true,
                message: '请上传附件',
                trigger: 'blur',
              }"
            > -->
            <eui-btn
                    v-if="row.aiCheckResult !== '分析中'"
                    type="text"
                    @click="handleUpload(row.categoryCode, row.orderSkuId, 'upload')"
            >
              <span
                style="color: #f0250f"
                v-if="row.aiCheckResult !== '不需要审查'"
                >*</span
              >
              上传
            </eui-btn>

            <eui-btn
                    type="text"
                    v-if="
                orderSkuIdArr.includes(row.orderSkuId) ||
                Number(row.hasAiAttach) === 1
              "
                    @click="handleUpload(row.categoryCode, row.orderSkuId, 'view')"
              >查看
            </eui-btn>
            <!-- </el-form-item> -->
          </template>
          <template v-slot:aiCheckResult="{ scope: { row } }">
            <div v-if="row.aiCheckResult !== '审查不通过'">
              {{ row.aiCheckResult }}
            </div>
            <eui-btn
                    :class="{
                'color-red': row.aiCheckResult === '审查不通过',
              }"
                    v-else
                    type="text"
                    font-size="12px"
                    @click="showCheckResult(row.requestId, row.aiCheckResult)"
            >
              {{ row.aiCheckResult }}
            </eui-btn>
          </template>
        </TableList>
      </el-form>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="orderTagPage.currentPage"
          :page-size="orderTagPage.pageSize"
          :total="tableData.length"
        ></el-pagination>
      </div>
    </div>
    <div
      class="container"
      v-if="type == 'orderConfirm' || supplierAttachList.length > 0"
    >
      <div class="common">供应商附件</div>
      <div v-if="type == 'orderConfirm'">
        <div class="flex-a-c margin-t10">
          <div class="margin-r10" style="font-size: 14px">附件：</div>
          <el-upload
            ref="uploadFile"
            :action="uploadUrl"
            :headers="headers"
            :show-file-list="false"
            :auto-upload="true"
            :on-success="getFileInfo"
            :before-upload="handleBeforeUpload"
          >
            <eui-btn icon="eicon-upload" iconPosition="left" type="secondary"
              >上传附件</eui-btn
            >
          </el-upload>
          <div class="tip-word">
            非必填，最多上传5个附件，格式不限，每个附件大小不超过200M。
          </div>
        </div>
        <!--附件样式 操作-->
        <div
          class="attach-mapper"
          v-if="supplierAttachList.length > 0"
          style="margin: 10px 20px 0 52px"
        >
          <div
            class="attach-box flex-sb"
            v-for="(item, fileIndex) in supplierAttachList"
            :key="fileIndex"
            :class="[
              fileIndex === 3 ? '' : 'margin-r20',
              fileIndex === 0 ? 'margin-b10' : '',
            ]"
          >
            <div class="attach-left">
              <div class="flex">
                <eui-icon
                  icon="eicon-file"
                  fontSize="16px"
                  color="#666666"
                  style="margin-top: 1px"
                ></eui-icon>
                <span>
                  <eui-tooltip-over
                    class="file-name"
                    :tooltipStyle="{ width: '180px' }"
                    style="display: inline-block; margin-left: 8px"
                    :content="item.name"
                  >
                    <span>{{ item.name }}</span>
                  </eui-tooltip-over>
                </span>
              </div>

              <div class="flex" style="margin-left: 24px">
                <div
                  class="label-item"
                  v-if="item.tags"
                  @click.stop="handleDelLabel(fileIndex)"
                >
                  {{ item.tags }}
                  <eui-icon
                    icon="eicon-close"
                    fontSize="10px"
                    color="#666666"
                    style="margin-bottom: 1px"
                  ></eui-icon>
                </div>
                <div class="choose-label" @click="handleChooseLabel(fileIndex)">
                  选择附件标签
                </div>
              </div>
            </div>
            <div class="attach-right" @click.stop="handleDelFile(fileIndex)">
              <eui-icon
                icon="eicon-close"
                fontSize="14px"
                color="#666666"
              ></eui-icon>
            </div>
          </div>
        </div>
      </div>
      <!--附件样式展示-->
      <div
        class="attach-mapper flex"
        style="flex-wrap: wrap"
        v-if="type !== 'orderConfirm'"
      >
        <div
          class="attach-box"
          :class="[
            fileIndex === 3 ? '' : 'margin-r20',
            fileIndex === 0 ? 'margin-b10' : '',
          ]"
          v-for="(item, fileIndex) in supplierAttachList"
          :key="fileIndex"
        >
          <div class="attach-left">
            <a target="_blank" :href="item.url" style="display: inline-block">
              <eui-tooltip-over
                class="file-name"
                :tooltipStyle="{ width: '230px' }"
                style="display: inline-block; margin-left: 4px"
                :content="item.name"
              >
                <span>{{ item.name }}</span>
              </eui-tooltip-over>
            </a>
            <div style="margin-top: 2px; margin-left: 4px">
              <div class="label-item" v-if="item.tags">{{ item.tags }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" style="padding: 20px">
      <div class="common">订单总计</div>
      <div class="order-sum">
        <div class="order-footer">
          <div>
            <span class="black">订单总价（含税）：</span>
            <span class="red" v-if="!handleChangePrice()"
              >¥ {{ orderBaseInfo.needPay }}</span
            >
            <span class="red" v-else>¥ {{ allPrice }}</span>
          </div>
          <div>
            <span class="black">运费合计：</span>
            <span class="red">¥ {{ showShippingCost() }}</span>
          </div>
        </div>
      </div>

      <!-- <orderSum :calculate="calculate" :shippingCost="shippingCost" /> -->
    </div>
    <div class="tip" v-if="type == 'orderConfirm'">请仔细核对商品信息</div>
    <div class="back">
      <div class="button el-icon-arrow-left" @click="toBack(null)">返回</div>

      <div
        class="operate"
        v-if="type == 'orderConfirm' || type == 'orderCancle'"
      >
        <div class="close refuse" v-debounce="handleOrderRefuse">拒绝</div>
        <div class="close confirm" v-debounce="() => supplierOrderConfirm('0')">
          订单确认
        </div>
      </div>
      <div
        class="button"
        v-if="isCanPrint(orderBaseInfo.orderStatusNum)"
        @click="handlePrint"
      >
        打印
      </div>
    </div>
    <epec-dialog
      dialogTitle="拒绝订单"
      :centerDialogVisible="showRefuseDialog"
      @updateVisible="handleUpdateVisible"
      @submitPopupData="submitPopupData"
      @resetPopupData="handleResetPopupData"
      :popupWidth="'600px'"
      :showClose="false"
      :showBtn="true"
    >
      <el-form :model="refuseForm" ref="refuseForm">
        您正在操作拒绝订单，此订单将直接取消，并无法恢复，请填写拒绝原因。
        <el-row>
          <el-form-item label="拒绝原因：" prop="refuseReason">
            <el-input
              placeholder="请填写拒绝原因（限50个字符）"
              show-word-limit
              type="textarea"
              maxlength="50"
              v-model="refuseForm.refuseReason"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button @click="handleResetPopupData">取 消</el-button>
        <el-button
          type="primary"
          v-debounce="
            () => supplierOrderConfirm(type == 'orderConfirm' ? '3' : '5')
          "
          >确 定</el-button
        >
      </span>
    </epec-dialog>

    <!-- 询比价收费 没有 缴费-->
    <e-dialog
      dialogTitle="提示"
      :centerDialogVisible="payVisible"
      @updateVisible="updatePayVisible"
      @submitPopupData="submitPayPopupData"
      @resetPopupData="updatePayVisible"
      buttonTip="前 往"
      :popupWidth="'400px'"
      :showClose="false"
      :showBtn="true"
    >
      <div>
        请前往 对账管理-收费通知书管理 中去缴纳服务费，再执行订单，谢谢。
      </div>
    </e-dialog>
    <!--易资源商品下单，供应商确认环节增加提醒-->
    <confirm-reminder-dialog
      :confirmReminderVisible="confirmReminderVisible"
      :ESourceData="ESourceData"
      v-if="confirmReminderVisible"
      @closeDialog="closeDialog"
      @supplierOrderConfirm="supplierOrderConfirm"
    />
    <!--选择附件标签-->
    <label-dialog
      v-if="labelVisible"
      :labelVisible.sync="labelVisible"
      :chooseLabelParent="chooseLabelParent"
      @confirmLabel="confirmLabel"
    />
    <!--同ip下单提示-->
    <same-ip-dialog v-if="sameIpTip" :sameIpTip.sync="sameIpTip" />
    <!--附件上传-->
    <attachment-upload
            v-if="attachmentUploadVisible"
            :attachmentUploadVisible.sync="attachmentUploadVisible"
            :categoryCode="categoryCode"
            :handleFlag="handleFlag"
            :viewTableData="viewTableData"
            :type="type"
            @dealAttachmentFileData="dealAttachmentFileData"
    />
    <!--数据报告-->
    <AIDataReport
      v-if="dataReportVisible"
      :dataReportVisible.sync="dataReportVisible"
      :target-id="targetId"
      :type="aiAuditType"
    />
  </div>
</template>

<script>
import TableList from '../../components/common/e-table-list';
import eTooltip from '../../components/common/e-tooltip';
import eDialog from '../../components/common/e-dialog';
import { calRoundNum } from '../../utils/utils';
import api from '../../api/order';
import epecDialog from '@/components/common/epecDialog.vue';
import orderDetailShow from './common/orderDetailShow.vue';
import labelDialog from './common/labelDialog';
import confirmReminderDialog from './common/confirmReminderDialog.vue';
import filingApi from '@/modules/projectA/api/filing';
import { epecToken } from '../../utils/globalData';
import sameIpDialog from './common/sameIpDialog';
import attachmentUpload from '../../components/common/attachmentUpload';
import AIDataReport from '../../components/common/AIDataReport.vue';
import {epecMallUrl} from '@/modules/projectA/api/config';

export default {
  name: 'orderDetailOrConfirm',
  components: {
    labelDialog,
    TableList,
    epecDialog,
    orderDetailShow,
    eTooltip,
    eDialog,
    confirmReminderDialog,
    sameIpDialog,
    attachmentUpload,
    AIDataReport,
  },
  computed: {
    allPrice() {
      let totalPrice = 0;
      this.tableData.forEach((item) => {
        totalPrice += Number(item.subtotal);
      });
      return totalPrice.toFixed(2);
    },
  },
  data() {
    return {
      targetId: '',
      aiAuditType: '',
      dataReportVisible: false,
      sameIpTip: false,
      supplierAttachList: [],
      uploadUrl: api.videoUploadUrl,
      headers: epecToken,
      confirmReminderVisible: false,
      ptRateFlag: false, //平台费率
      payVisible: false,
      checkIsPayFlag: true, //已经缴费
      showRefuseDialog: false,
      refuseForm: {
        refuseReason: '',
      },
      pageSize: 10, //    每页的数据
      currentPage: 1, //初始页
      ESourceData: [], //判断是否有易资源商品，有弹框
      query: {
        orderId: null,
        purchaseCompanyId: null,
      },
      calculate: {
        type: 'confirm',
        skuCount: 0, //商品总件数
        needPay: 0, //订单总价
        taxationSum: 0.0, //税费
        freightSum: 0.0,
      },
      type: '',
      orderBaseInfo: {},
      orderSource: '',
      invoiceInfo: {},
      shipmentInfo: {},
      orderSkuInfo: {},
      loading: false,
      tableData: [],
      tableLabel: [
        {
          label: '商品名称',
          param: 'productName',
          align: 'left',
          slot: 'productName',
        },
        {
          label: '商品规格',
          param: 'displaySkuOptions',
          align: 'center',
          width: '80',
          slot: 'displaySkuOptions',
        },
        {
          label: '商品编码',
          param: 'productSkuCode',
          align: 'center',
          width: '160',
          slot: 'productSkuCode',
        },
        {
          label: '商品单价（含税 元）',
          param: 'price',
          align: 'center',
          width: '150',
          slot: 'shoppingUnitPrice',
        },
        {
          label: '购买数量',
          param: 'quantity',
          align: 'center',
          width: '100',
          slot: 'quantity',
        },
        {
          label: '计量单位',
          param: 'goodsUnitName',
          align: 'center',
          width: '80',
        },
        {
          label: '单项运费  \n\n  (可根据实际情况选填)',
          param: 'shippingCost',
          align: 'center',
          width: '190',
          slot: 'shippingCost',
        },
        {
          label: '小计（元）',
          param: 'subtotal',
          align: 'center',
          slot: 'subtotal',
          width: '120',
        },
      ],
      //有溢装率
      tableParam: [
        {
          label: '商品名称',
          param: 'productName',
          align: 'left',
          slot: 'productName',
        },
        {
          label: '商品规格',
          param: 'displaySkuOptions',
          align: 'center',
          width: '80',
          slot: 'displaySkuOptions',
        },
        {
          label: '商品编码',
          param: 'productSkuCode',
          align: 'center',
          width: '160',
          slot: 'productSkuCode',
        },
        {
          label: '商品单价（含税 元）',
          param: 'price',
          align: 'center',
          width: '140',
          slot: 'shoppingUnitPrice',
        },
        {
          label: '溢装率',
          param: 'overShipmentRate',
          align: 'center',
          width: '100',
          render: (row) => {
            return row.overShipmentRate
              ? Number(row.overShipmentRate) * 100 + '%'
              : '0%';
          },
        },
        {
          label: '购买数量',
          param: 'quantity',
          align: 'center',
          width: '100',
          slot: 'quantity',
        },
        {
          label: '计量单位',
          param: 'goodsUnitName',
          align: 'center',
          width: '100',
        },
        {
          label: '单项运费  \n\n  (可根据实际情况选填)',
          param: 'shippingCost',
          align: 'center',
          width: '190',
          slot: 'shippingCost',
        },
        {
          label: '小计（元）',
          param: 'subtotal',
          align: 'center',
          slot: 'subtotal',
          width: '120',
        },
      ],
      skuAdjustList: [],
      orderTagPage: {
        currentPage: 1,
        pageSize: 1000,
        pageTotal: 0,
      },
      shippingCost: 0,
      labelFileIndex: 0,
      chooseLabelParent: '',
      labelVisible: false,

      attachmentUploadVisible: false,
      handleFlag: '',
      lbbm: '',
      categoryCode: '',
      orderSkuId: '',
      aiCheckFileList: [],
      attachmentUploadTableData: [], //用于查看
      viewTableData: [],

      orderSkuIdArr: [],

      nanJingWhiteData: false,
      productForm: {
        aiCheckFileList: [
          {
            attachList: [],
            orderSkuId: '',
          },
        ],
      },
      aiCheckResultTip:
        'AI审查建议结果仅作为业务处理的参考依据，不会中断或者阻止正常业务流程。',
    };
  },
  methods: {
    showCheckResult(requestId, aiCheckResult) {
      if (aiCheckResult === '审查不通过') {
        // this.targetId = orderSkuId;
        // this.aiAuditType = 1;
        // this.dataReportVisible = true;
        window.open(`${epecMallUrl}/intelligentReview?id=${requestId}`, '_blank');
      }
    },
    //处理附件上传数据
    dealAttachmentFileData(tableData) {
      const isExistIndex = this.aiCheckFileList.findIndex(
        (item) => item.orderSkuId === this.orderSkuId
      );
      const attachListArr = [];

      tableData.forEach((item) => {
        if (item.attachList.length > 0) {
          item.attachList.forEach((attachItem) => {
            attachListArr.push({ ...attachItem });
          });
        }
      });

      let params = {
        orderSkuId: this.orderSkuId,
        attachList: attachListArr,
      };
      //用于查看数据
      let viewParams = {
        orderSkuId: this.orderSkuId,
        tableData,
      };

      if (isExistIndex === -1) {
        //不存在
        this.aiCheckFileList.push(params);
        this.attachmentUploadTableData.push(viewParams);
        this.orderSkuIdArr.push(this.orderSkuId);
      } else {
        this.aiCheckFileList[isExistIndex] = params;
        this.attachmentUploadTableData[isExistIndex] = viewParams;
      }

      if (this.type == 'orderDetail') {
        this.scSkuAttachBatchAttach(params);
      }
    },
    async scSkuAttachBatchAttach(params) {
      const res = await api.scSkuAttachBatchAttach(params);
      if (res.code === '200') {
        // this.$message.success('保存成功');
      }
    },
    async scSkuAttachQuery(params) {
      const res = await api.scSkuAttachQuery(params);
      if (res.code === '200') {
        this.viewTableData = res.data || [];
      }
    },
    async handleUpload(categoryCode, orderSkuId, handleFlag) {
      // this.lbbm = lbbm;
      this.categoryCode = categoryCode;
      this.orderSkuId = orderSkuId;
      this.handleFlag = handleFlag;

      // if (handleFlag === 'view' || handleFlag === 'upload') {
      //   if (this.type === 'orderDetail' || this.type === 'orderConfirm') {
      //     await this.scSkuAttachQuery({ orderSkuId: orderSkuId });
      //   } else {
      //     const uploadTableData = this.attachmentUploadTableData.filter(
      //       (item) => item.orderSkuId === orderSkuId
      //     );
      //     this.viewTableData = uploadTableData[0].tableData;
      //   }
      // }
      if (handleFlag === 'view') {
        if (this.type === 'orderConfirm') {
          await this.scSkuAttachQuery({ orderSkuId: orderSkuId });
          //当viewTableData不为空时 组装viewTableData
          if (this.viewTableData.length > 0) {
            this.viewTableData = this.viewTableData.map((item) => {
              let obj = {
                name: item.name,
                url: item.url,
                categoryReviewAttachmentId: item.categoryReviewAttachmentId,
              };
              return {
                id: item.categoryReviewAttachmentId,
                attachList: [obj],
              };
            });
          }
          if (this.attachmentUploadTableData.length > 0) {
            const uploadTableData = this.attachmentUploadTableData.filter(
              (item) => item.orderSkuId === orderSkuId
            );
            this.viewTableData = uploadTableData[0].tableData;
          }

        } else {
          await this.scSkuAttachQuery({ orderSkuId: orderSkuId });
          // const uploadTableData = this.attachmentUploadTableData.filter(
          //   (item) => item.orderSkuId === orderSkuId
          // );
          // this.viewTableData = uploadTableData[0].tableData;
        }
      } else if (handleFlag === 'upload') {
        if (this.type === 'orderDetail') {
          // await this.scSkuAttachBatchAttach({ orderSkuId: orderSkuId });
          await this.scSkuAttachQuery({ orderSkuId: orderSkuId });
        } else {
          await this.scSkuAttachQuery({ orderSkuId: orderSkuId });
          if (this.viewTableData.length > 0) {
            this.viewTableData = this.viewTableData.map((item) => {
              let obj = {
                name: item.name,
                url: item.url,
                categoryReviewAttachmentId: item.categoryReviewAttachmentId,
              };
              return {
                id: item.categoryReviewAttachmentId,
                attachList: [obj],
              };
            });
          }
          if (this.attachmentUploadTableData.length > 0) {
            const uploadTableData = this.attachmentUploadTableData.filter(
              (item) => item.orderSkuId === orderSkuId
            );
            this.viewTableData =
              uploadTableData.length > 0 ? uploadTableData[0].tableData : [];
          }
        }
      }

      this.attachmentUploadVisible = true;
    },
    //删除文件
    handleDelFile(fileIndex) {
      this.supplierAttachList.splice(fileIndex, 1);
    },
    //删除选中标签
    handleDelLabel(fileIndex) {
      this.supplierAttachList[fileIndex].tags = '';
    },
    handleChooseLabel(fileIndex) {
      this.chooseLabelParent = this.supplierAttachList[fileIndex].tags || '';

      this.labelFileIndex = fileIndex; //供应商附件得 index
      this.labelVisible = true;
    },
    //确认选中label
    confirmLabel(label) {
      this.supplierAttachList[this.labelFileIndex].tags = label;
    },
    handleBeforeUpload(file) {
      let size = file.size / 1024 / 1024;
      if (size > 200) {
        this.$message.warning({ message: '附件不能超过200M。' });
        return;
      }
    },
    getFileInfo(res, file) {
      if (this.supplierAttachList.length === 5) {
        this.$message.warning({ message: '只能上传五个附件。' });
        return false;
      }
      if (res.success) {
        let params = {
          url: file.response.data.url,
          name: file.name,
          tags: '',
        };
        this.supplierAttachList.push(params);
      }
    },
    // 保留两位小数
    moneyToFixed(num) {
      return (Math.round(num * 100) / 100).toFixed(2);
    },
    closeDialog() {
      this.confirmReminderVisible = false;
    },
    //是否可以 修改单价
    handleChangePrice() {
      let orderSource = this.orderBaseInfo.orderSource;
      let isIntervalPriceOrder = this.orderBaseInfo.isIntervalPriceOrder;

      if (orderSource != 4 && orderSource != 31) {
        if (orderSource == 5) {
          //中交外部订单可以修改
          if (isIntervalPriceOrder == 2) {
            return true; //可以修改
          } else {
            return false; //不可以修改
          }
        } else {
          return true; //可以修改
        }
      } else {
        return false; //不可以修改
      }
    },
    //是否可以  修改运费   5--中交 ； 4--询比价 ；31--融合采购计划
    handleChange() {
      let orderSource = this.orderBaseInfo.orderSource;
      if (orderSource != 4 && orderSource != 31 && orderSource != 5) {
        return true;
      } else {
        return false;
      }
    },
    showShippingCost() {
      if (this.orderBaseInfo.invoiceModeCode == 2) {
        return this.shippingCost
          ? Number(this.shippingCost).toFixed(2)
          : '0.00';
      } else {
        if (
          this.orderBaseInfo.orderStatusNum == 17 ||
          this.orderBaseInfo.orderStatusNum == 18
        ) {
          return this.shippingCost
            ? Number(this.shippingCost).toFixed(2)
            : '0.00';
        } else {
          return '0.00';
        }
      }
    },
    //待采购商确认、待供应商确认、待审批、变更中 、取消中 、已取消（采购商取消） 的不显示  其他都显示可以打印
    isCanPrint(data) {
      if (
        data != '17' &&
        data != '18' &&
        data != '12' &&
        data != '72' &&
        data != '71' &&
        data != '7'
      ) {
        return true;
      } else {
        return false;
      }
    },
    clearNoNum(obj) {
      //先把非数字的都替换掉，除了数字和.
      obj.value = obj.value.replace(/[^\d.]/g, '');
      //必须保证第一个为数字而不是.
      obj.value = obj.value.replace(/^\./g, '');
      //保证只有出现一个.而没有多个.
      obj.value = obj.value.replace(/\.{2,}/g, '.');
      //保证.只出现一次，而不能出现两次以上
      obj.value = obj.value
        .replace('.', '$#$')
        .replace(/\./g, '')
        .replace('$#$', '.');
    },
    //计算
    calFee(data, flag) {
      if (this.skuAdjustList.length > 0) {
        let index = this.skuAdjustList.findIndex(
          (item) => item.orderSkuId == data.orderSkuId
        );
        if (index != -1) {
          this.skuAdjustList.splice(index, 1);
        }
      }
      //修改运费
      if (flag == 'shippingCost') {
        //校验为负数
        if (Number(data.shippingCost) < 0) {
          data.shippingCost = 0;
          let sibleShippingCost = 0;
          this.tableData.map(
            (item) => (this.sibleShippingCost += Number(item.shippingCost))
          );
          this.shippingCost = sibleShippingCost;
          return this.$message.warning('单项运费仅可输入非负数。');
        }
        if (data.shippingCost) {
          let param = {
            // price:data.price,
            // subtotal:data.price*data.quantity,
            orderSkuId: data.orderSkuId,
            priceAdjuct: Number(data.price),
            shippingCostAdjust: data.shippingCost
              ? Number(data.shippingCost).toFixed(2)
              : '0',
          };
          this.skuAdjustList.push(param);
        }
        //重新计算运费
        this.shippingCost = 0;
        this.skuAdjustList.map(
          (item) => (this.shippingCost += Number(item.shippingCostAdjust))
        );
        this.tableData.forEach((item) => {
          if (!this.shippingCost) {
            this.$set(item, 'shippingCost', 0);
          }
          if (
            Number(this.shippingCost) > 0 &&
            item.orderSkuId == data.orderSkuId
          ) {
            this.$set(
              item,
              'shippingCost',
              Number(item.shippingCost).toFixed(2)
            );
          }
        });
      } else {
        //精确计算小计
        let subtotal = calRoundNum(
          Number(data.price).toFixed(2),
          data.quantity
        );
        //乘100获取精度
        let total = calRoundNum(subtotal, 100);

        //修改
        let param = {
          price: Number(data.price).toFixed(2),
          subtotal: Number(Math.round(total) / 100).toFixed(2),
          orderSkuId: data.orderSkuId,
          priceAdjuct: Number(data.price).toFixed(2),
          shippingCostAdjust: data.shippingCost
            ? Number(data.shippingCost).toFixed(2)
            : '0',
        };
        this.skuAdjustList.push(param);
        this.tableData.forEach((item) => {
          if (item.orderSkuId == data.orderSkuId) {
            item.price = Number(data.price).toFixed(2);
            this.$set(
              item,
              'subtotal',
              Number(Math.round(total) / 100).toFixed(2)
            );
          }
        });
        //面议价 禁止 商品单价为 0
        if (!Number(data.price) || Number(data.price) < 0) {
          this.$message.warning('请核对商品单价，商品单价必须为正数。');
        }
      }
    },
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
    },
    //收费跳转
    submitPayPopupData() {
      this.$router.push({ path: '/noticeOfCharge' });
      this.payVisible = false;
    },
    //收费关闭
    updatePayVisible() {
      this.payVisible = false;
    },
    //操作订单拒绝
    handleOrderRefuse() {
      this.showRefuseDialog = true;
    },
    handleUpdateVisible() {},
    submitPopupData() {
      if (!this.refuseForm.refuseReason) {
        return this.$message.warning('拒绝原因不能为空');
      }
      let param = this.type == 'orderConfirm' ? '3' : '5';
      this.supplierOrderConfirm(param);
    },
    handleResetPopupData() {
      this.showRefuseDialog = false;
      this.refuseForm.refuseReason = '';
    },
    //默认费率
    async queryConfigList() {
      const ptRateRes = await filingApi.queryConfigList([
        'chargeNotice.enquiryServiceRate',
      ]);
      if (ptRateRes.success && Number(ptRateRes.data[0].configValue) > 0) {
        this.ptRateFlag = true;
      } else {
        this.ptRateFlag = false;
      }
    },
    //完成确认
    supplierOrderConfirm(param) {
      const { serviceRate, externalResourceType } = this.orderBaseInfo;
      //易资源有数据 并且 就 弹框
      if (
        this.ESourceData.length > 0 &&
        !this.confirmReminderVisible &&
        param === '0' &&
        externalResourceType === 0 &&
        serviceRate !== 0
      ) {
        this.confirmReminderVisible = true;
        return false;
      }

      //询比价的弹框
      const createTime = new Date(this.orderBaseInfo.submitTime);
      createTime.setHours(0, 0, 0, 0);
      let targetDate = Object;
      if (process.env.NODE_ENV === 'production') {
        targetDate = new Date(2023, 10, 8); //月份减1
      } else {
        targetDate = new Date(2023, 9, 20); //月份减1
      }
      targetDate.setHours(0, 0, 0, 0);

      if (
        !this.checkIsPayFlag &&
        targetDate.getTime() < createTime.getTime() &&
        this.ptRateFlag &&
        param === '0'
      ) {
        this.payVisible = true;
        return false;
      }

      if (this.type == 'orderConfirm') {
        //校验面议价
        let bargainPricePlag = false;
        this.skuAdjustList.forEach((item) => {
          if (Number(item.price) == 0 || Number(item.price) < 0)
            bargainPricePlag = true;
        });
        if (bargainPricePlag) {
          this.$message.warning('请核对商品单价，商品单价必须为正数。');
          return false;
        } else {
          this.tableData.forEach((item) => {
            if (Number(item.price) == 0 || Number(item.price) < 0)
              bargainPricePlag = true;
          });
          if (bargainPricePlag) {
            this.$message.warning('请核对商品单价，商品单价必须为正数。');
            return false;
          }
        }

        //校验附件的必传
        const isMustAttachData = this.tableData.filter(
          (item) => item.isMustAttach
        );
        if (
          isMustAttachData.length !== 0 &&
          isMustAttachData.length !== this.aiCheckFileList.length
        ) {
          this.$message.warning('请先上传“必传”附件后再点击“订单确认”按钮。');
          return false;
        }

        let params = {
          skuAdjustList: this.skuAdjustList,
          ...this.query,
          refuseWorkflowStatus: param == '3' ? 3 : 0,
          needPay:
            this.skuAdjustList.length > 0
              ? (Number(this.shippingCost) + Number(this.allPrice)).toFixed(2)
              : null,
          shippingCost: this.shippingCost
            ? Number(this.shippingCost).toFixed(2)
            : '0.00',
          refuseReason: this.refuseForm.refuseReason,
          supplierAttachList: this.supplierAttachList,
          aiCheckFileList: this.aiCheckFileList,
        };
        this.$refs.productForm.validate((valid) => {
          if (valid) {
            console.log(valid, 'valid');
          } else {
            return false;
          }
        });
        console.log(params, 'params');
        //订单确认
        api.supplierConfirmOrder(params).then((res) => {
          if (res.code == '200') {
            if (!this.shippingCost) {
              this.$message.success(
                param == '0' ? '订单确认成功。' : '订单确认拒绝，已取消。'
              );
            } else {
              let arr = [
                '您的订单已确认，',
                '由于您修改了订单信息，需由采购商再次确认。',
              ];
              let str = arr.join(' <br/> ');
              this.$message({
                dangerouslyUseHTMLString: true,
                message: str,
                type: 'success',
              });
            }
            this.confirmReminderVisible = false;
            this.showRefuseDialog = false;
            setTimeout(() => {
              let times = new Date();
              times = times.getTime();
              this.toBack(times);
            }, 1000);
          } else if (res.code === 'SAME_IP_ADDRESS') {
            this.sameIpTip = true;
          }
        });
      }
      //订单取消
      if (this.type == 'orderCancle') {
        api
          .cancelConfirm({
            orderId: this.query.orderId,
            refuseWorkflowStatus: param,
          })
          .then((res) => {
            if (res.code == '200') {
              this.$message.success(param == '5' ? '拒绝成功' : '取消成功');
              setTimeout(() => {
                let times = new Date();
                times = times.getTime();
                this.toBack(times);
              }, 1000);
            }
          });
      }
    },
    async getOrderDetail() {
      let res = await api.queryOrderDetail(this.query);
      if (res.code == 200) {
        this.invoiceInfo = res.data.orderInvoiceVO
          ? res.data.orderInvoiceVO
          : {};
        this.shipmentInfo = res.data.shipmentVO;
        this.supplierAttachList = res.data.supplierAttachList || [];
        this.orderBaseInfo = res.data;
        this.orderSource = this.orderBaseInfo.orderSource;
        this.calculate.needPay = Number(res.data.needPay).toFixed(2);
        this.calculate.skuCount = res.data.skuCount;
        this.shippingCost = this.orderBaseInfo.shippingCost
          ? Number(this.orderBaseInfo.shippingCost).toFixed(2)
          : 0;
      }

      let params = JSON.parse(JSON.stringify(this.query));
      params.pageNum = this.orderTagPage.currentPage;
      params.pageSize = this.orderTagPage.pageSize;
      let skuListRes = await api.queryOrderSkuList(params);
      if (skuListRes.code == 200) {
        this.tableData = skuListRes.data.records;
        this.orderTagPage.pageTotal = skuListRes.data.total;
        if (
          this.type == 'orderConfirm' &&
          this.handleChange(this.orderSource)
        ) {
          this.tableData.forEach((item) => {
            this.$set(item, 'shippingCost', 0);
          });
        }
      }
      if (this.invoiceInfo.invoiceMode === 2) {
        this.$set(this.invoiceInfo, 'invoiceModeStr', '下单后立即开票');
      } else if (this.invoiceInfo.invoiceMode === 3) {
        this.$set(this.invoiceInfo, 'invoiceModeStr', '与其他订单合并开票');
      } else {
        this.$set(this.invoiceInfo, 'invoiceModeStr', '');
      }
      console.log(this.tableData, 'this.tableData');
      //询比价 判断是否 收费
      if (
        Number(this.orderBaseInfo.orderSource) === 4 ||
        Number(this.$route.query.purchaseRequestType) === 4
      ) {
        this.checkIsPay(); //收费单详情
      }
    },
    //收费单详情  true就是已经交了或者压根没生成收费单; 只有 false  才 弹框
    async checkIsPay() {
      await api
        .checkIsPay({
          businessId: this.tableData[0].productId,
          businessType: 2,
        })
        .then((res) => {
          if (res.success) {
            this.checkIsPayFlag = res.data;
          }
        });
    },

    toBack(times) {
      if (times !== null) {
        this.$router.push({ path: '/orderManage', query: { t: times } });
      } else {
        this.$router.push({ path: '/orderManage' });
      }
      // this.$router.push({ path: '/orderManage' });
    },
    handlePrint() {
      let newpage = this.$router.resolve({
        name: 'e-print',
        query: {
          orderId: this.query.orderId,
          purchaseCompanyId: this.query.purchaseCompanyId,
        },
      });
      window.open(newpage.href, '_blank');
    },
    async queryESourceProductList() {
      await api.queryESourceProductList(this.query).then((res) => {
        if (res.success) {
          this.ESourceData = res.data.map(
            (item, index) => index + 1 + '. ' + item.productName
          );
        }
      });
    },
  },
  mounted() {
    this.nanJingWhiteData = JSON.parse(
      localStorage.getItem('nanJingWhiteData')
    );

    this.type = this.$route.query.type;
    this.query.orderId = this.$route.query.orderId;
    this.query.purchaseCompanyId = this.$route.query.purchaseCompanyId;
    this.getOrderDetail();
    this.queryConfigList(); //默认费率

    let attachmentData = {
      label: '附件',
      param: '',
      align: 'center',
      slot: 'attachmentUpload',
      width: '130px',
    };

    let aiData = {
      label: 'AI审查建议结果',
      param: 'aiCheckResult',
      align: 'center',
      slot: 'aiCheckResult',
      width: '130px',
      headerSlot: 'aiCheckResultHeader',
    };

    if (this.type == 'orderConfirm' || this.type == 'orderCancle') {
      this.queryESourceProductList(); //判断是否有易资源商品，有弹框
    }

    //有权限
    // if (this.nanJingWhiteData) {
      if (this.type == 'orderConfirm') {
        this.tableLabel.push(attachmentData);
        this.tableParam.push(attachmentData);
      }
      if (this.type == 'orderDetail') {
        this.tableLabel.push(attachmentData);
        this.tableParam.push(attachmentData);
        this.tableLabel.push(aiData);
        this.tableParam.push(aiData);
      }
    // }
  },
};
</script>

<style scoped lang="scss">
.order-detail {
  width: 100%;

  .color-red {
    color: #f0250f;
  }
  .good-price-box {
    margin-right: 4px;
  }

  .tip-word {
    color: #999;
    display: inline-block;
    width: 500px;
    margin-left: 10px;
    font-size: 12px;
  }

  .attach-mapper {
    display: flex;
    flex-wrap: wrap;

    .attach-box {
      width: 250px;
      height: 60px;
      padding: 6px 10px;
      background: linear-gradient(
        90deg,
        #f5f5f5 0%,
        rgba(245, 245, 245, 0.2) 100%
      );

      .cursor-show {
        cursor: pointer;
      }

      .attach-left {
        width: 216px;

        .margin-t4 {
          margin-top: 4px;
        }

        .label-item {
          width: 80px;
          height: 20px;
          line-height: 19px;
          border: 1px solid #d9d9d9;
          margin-right: 6px;
          color: #666;
          text-align: center;
          font-size: 12px;
          cursor: pointer;
          background-color: #fff;
          &:hover {
            background-color: #e9f3ff;
            border-color: #2587ff;
            color: #2587ff;
          }
        }

        .choose-label {
          width: 100px;
          height: 20px;
          line-height: 18px;
          border: 1px solid #2587ff;
          color: #2587ff;
          font-size: 12px;
          text-align: center;
          cursor: pointer;

          &:hover {
            background-color: #e9f3ff;
          }
        }
      }

      .attach-right {
        margin-top: 10px;
        cursor: pointer;
      }

      .file-name {
        color: #0064c8;
      }
    }
  }
  .jc-price-container {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      position: relative;
      z-index: 1;
    }
    .jc-price {
      height: 18px;
      padding: 0 10px 0 20px;
      margin-left: -20px;
      align-self: flex-end;
      background: #ffeac9;
      line-height: 17px;
      font-size: 14px;
      font-weight: 400;
      border-radius: 4px;
      color: #f0250f;
    }
  }
  .break {
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .tip {
    display: flex;
    justify-content: flex-end;
    color: #ef4c56;
    font-size: 12px;
    margin: 20px 0 10px 0;
  }
  .line {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .no-border {
    ::v-deep .el-input__inner {
      padding-left: 4px;
      border-color: transparent;
    }
  }
  ::v-deep .el-input__inner:focus {
    border-color: #2587ff;
  }
  .refuse-form333 {
    width: 80%;
    display: flex;
    justify-content: center;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
  }
  .order-sum {
    margin-top: 10px;
    border: 1px solid #d9d9d9;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;

    .order-footer {
      margin-bottom: 10px;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      margin-right: 10px;
      .black {
        color: #333;
        font-size: 14px;
        font-weight: normal;
      }
      div {
        margin-top: 16px;

        .red {
          color: red;
        }

        .imp {
          font-size: 16px;
          font-weight: bold;
          color: #333333;
        }
      }
    }
  }
  .back {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .button {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border: 1px solid #d9d9d9;
      text-align: center;
      cursor: pointer;
      background: #fff;
      &:hover,
      :active {
        border: 1px solid #2587ff;
        color: #2587ff;
      }
    }

    .operate {
      display: flex;

      .close {
        width: 96px;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        background: #2782ec;
        font-weight: 400;
        color: #fff;
        text-align: center;
        cursor: pointer;
        &:hover {
          background-color: #126edf;
        }
      }

      .refuse {
        background: #fff;
        margin-right: 20px;
        color: #333;
        border: 1px solid transparent;
        &:hover,
        :active {
          border: 1px solid #2587ff;
          background: #fff;
          color: #2587ff;
        }
      }
    }
  }

  .common {
    font-size: 14px;
    line-height: 14px;
    font-weight: bold;
    color: #333;
    font-style: normal;
    margin-bottom: 10px;
  }

  .order-main {
    padding: 20px;
    ul {
      display: flex;
      justify-content: center;
      border: 1px solid #ededed;
      margin-top: 10px;

      li {
        width: 20%;
        border-right: 1px solid #ededed;
        padding-bottom: 10px;
        .title {
          width: 100%;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          font-weight: 500;
          color: #333333;
          background: #f5f5f5;
          padding-left: 12px;
        }

        .little-title {
          padding: 10px 0 0 12px;
          font-size: 12px;
          font-weight: 400;
          color: #999999;
        }

        .cus-info {
          margin: 5px 0 0 12px;
          font-size: 12px;
          font-weight: 400;
          color: #333333;
        }

        .red {
          color: red;
        }
      }

      li:first-child {
        padding-left: 0px;
      }

      li:last-child {
        border-right: none;
        word-wrap: break-word;
      }
    }
  }
  //::v-deep
}
</style>
